module.exports = __webpack_public_path__ + "media/static/logo-350ecf668198d29efb7de78fdd272eb4.jpg";